export type NotificationChannelType = "email" | "whatsapp";

export function getNotificationChannelBadge(channel: NotificationChannelType): {
  label: string;
  className: string;
} {
  if (channel === "whatsapp") {
    return {
      label: "WhatsApp",
      className: "border-emerald-200 bg-emerald-50 text-emerald-800",
    };
  }

  return {
    label: "E-mail",
    className: "border-sky-200 bg-sky-50 text-sky-800",
  };
}
